import axios from "axios";
import dayjs from "dayjs";
import { PageProps } from "gatsby";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { type BlogPost } from "../../api/blog/blog.types";
// import SmallBanner from "../../components/common/SmallBanner";
import Layout from "../../components/layouts/Layout";
import HeroSection from "../../components/newVersion/HeroSection";
import RenderLoading from "../../templates/blog/components/loading";
import RenderPosts from "../../templates/blog/components/renderPosts";

// Importamos el idioma español para dayjs y lo activamos
require("dayjs/locale/es");
dayjs.locale("es");

// Activamos plugin de dayjs para mostrar la fecha en formato relativo
const relativeTime = require("dayjs/plugin/relativeTime");
dayjs.extend(relativeTime);

const Component = ({ location }: PageProps) => {
    const [data, setData] = useState<BlogPost[] | null>(null);
    const [loading, setLoading] = useState(false);

    // Obtenemos page del query string
    const query = new URLSearchParams(location.search);
    const page = Number(query.get("page") ?? 1);
    // const rawPageSize = Number(query.get("pageSize") ?? 10);

    useEffect(() => {
        async function fetchData() {
            setLoading(true);

            const toastId = toast.loading("Cargando datos...", {
                position: "bottom-center",
            });

            const rawData = await getPosts({ page });
            setData(rawData);

            setLoading(false);
            toast.dismiss(toastId);
        }

        fetchData();
    }, [page]);

    return (
        <Layout
            seo={{
                title: "iOpos Insight",
                description:
                    "Noticias, consejos y recursos imprescindibles para tener éxito en las oposiciones",
                image: "https://www.iopos.es/images/bgs/bgBlog.jpg",
            }}
            mode="fixed"
        >
            <HeroSection
                filename={"bgs/bgBlog"}
                firstTitle={"iOpos Insight"}
                secondTitle={"Nuestro Blog"}
                thirdTitle="Recursos, herramientas y consejos pensados para que avances con **claridad, constancia y resultados**."
                showScrollDownIcon={true}
            />

            {loading && <RenderLoading />}
            {data && (
                <div className="container mx-auto py-20">
                    <RenderPosts
                        loading={loading}
                        data={data}
                        paginationBase={`/blog`}
                        firstExpanded={true}
                    />
                </div>
            )}
        </Layout>
    );
};

const getPosts = async ({
    page = 1,
}: {
    page?: number;
}): Promise<BlogPost[] | null> => {
    try {
        const url = `/.netlify/functions/posts`;
        const params = {
            page: page ?? 1,
        };

        const options = {
            headers: {
                "Content-Type": "application/json",
                "Strapi-Response-Format": "v4",
            },
        };

        const { data } = await axios.post(url, params, options);

        return data?.posts;
    } catch (err) {
        console.error(err);
        return null;
    }
};

export default Component;
